import type { Router } from 'vue-router'
import { nextTick } from 'vue'
import { getReporter } from './reporter'

/**
 * 注册路由切换性能监听
 *
 * 通过独立的 beforeEach/afterEach 钩子测量路由切换耗时，
 * 不修改现有 guard.ts 中的鉴权和 NProgress 逻辑
 */
export function setupNavigationMetrics(router: Router): void {
  let navigationStart = 0

  router.beforeEach((_to, _from, next) => {
    navigationStart = performance.now()
    next()
  })

  router.afterEach(to => {
    if (!navigationStart) return

    const start = navigationStart
    navigationStart = 0

    nextTick(() => {
      const duration = performance.now() - start
      const reporter = getReporter()
      if (!reporter) return

      reporter.addNavigation({
        route: to.path,
        duration,
        timestamp: Date.now(),
      })
    })
  })
}
